import { Component } from 'react';
import * as React from 'react';


interface IProps {
    AddressesCount: number
    SelectedTab: 'Addresses' | 'Experience' | 'Specializations',
    OnTabSelected: (selectedTab: 'Addresses' | 'Experience' | 'Specializations') => void
}

export class TabsComponent extends Component<IProps, any> {
    constructor(props) {
        super(props);

        this.OnAddressesSelected = this.OnAddressesSelected.bind(this);
        this.OnExperienceSelected = this.OnExperienceSelected.bind(this);
        this.OnSpecializationsSelected = this.OnSpecializationsSelected.bind(this);
    }

    public render() {
        return (
            <div className="tabs-component section">
                <div onClick={this.OnAddressesSelected}
                    className={this.props.SelectedTab === 'Addresses' ? 'selected-tab' : ''}>
                    Adresy ({this.props.AddressesCount.toString()})
                </div>
                <div onClick={this.OnExperienceSelected}
                    className={this.props.SelectedTab === 'Experience' ? 'selected-tab' : ''}>
                    Doświadczenie
                </div>
                <div onClick={this.OnSpecializationsSelected}
                    className={this.props.SelectedTab === 'Specializations' ? 'selected-tab' : ''}>
                    Specjalności
                </div>
            </div>
        );
    }

    private OnAddressesSelected(evt) {
        this.props.OnTabSelected('Addresses')
    }

    private OnExperienceSelected(evt) {
        this.props.OnTabSelected('Experience')
    }

    private OnSpecializationsSelected(evt) {
        this.props.OnTabSelected('Specializations')
    }
}


// WEBPACK FOOTER //
// ./src/components/PhysiotherapistView/Tabs.tsx